import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/AuthContext';
import axios from 'axios';
import defaultImg from "../../assets/default.jpeg"; // Default image
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';

export default function GrievanceCreate({ open, onClose }) {
  const location = useLocation();
  const { user } = useAuth();
  const [form, setForm] = useState({ subject: '', description: '' });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const API_URL =process.env.REACT_APP_API_URL

  var navigate=useNavigate()
  useEffect(() => {
    // Clear errors when user types
    if (form.subject && errors.subject) setErrors(prev => ({ ...prev, subject: '' }));
    if (form.description && errors.description) setErrors(prev => ({ ...prev, description: '' }));
  }, [form, errors]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!form.subject.trim()) newErrors.subject = 'Subject cannot be empty';
    if (!form.description.trim()) newErrors.description = 'Description cannot be empty';
    if (Object.keys(newErrors).length > 0) return setErrors(newErrors);
  
    const payload = {
      senderId: user?.employeeProfile?._id,
      userName: user?.employeeProfile?.name,
      subject: form?.subject.trim(),
      message: form?.description.trim(),
      status: 'unseen',
    };
  console.log("payload---",payload)
    try {
      setIsSubmitting(true);
      const response = await axios.post(`${API_URL}grievance`, payload);
  
      if (response?.data?.success) {
        toast.success(response.data.message || "Grievance created successfully");
        setTimeout(() => {
          if (location.pathname === "/grievence-list") {
            window.location.reload();
          } else {
            navigate("/grievence-list");
          }
        }, 3000);
      }
      
  
      setForm({ subject: '', description: '' });
      onClose();
    } catch (err) {
      console.error('Failed to send grievance:', err);
      toast.error('Failed to create grievance');
    } finally {
      setIsSubmitting(false);
    }
  };
  

  // Determine image: use default if empty or null
  const profileImg = user?.employeeProfile?.employeePhoto
    ? user.employeeProfile.employeePhoto
    : defaultImg;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 border-b pb-2">📩 Create Grievance</h2>

        <div className="flex items-center mb-4 space-x-4">
          <img
            src={profileImg}
            alt={user?.name || 'User profile'}
            className="w-12 h-12 rounded-full object-cover bg-gray-200"
          />
          <div>
            <p className="font-medium text-gray-800">{user?.name}</p>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>
        </div>

        <input
          name="subject"
          value={form.subject}
          onChange={handleChange}
          placeholder="Subject"
          className={`w-full mb-2 px-3 py-2 border rounded focus:outline-none focus:ring-2 transition ${
            errors.subject ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
          }`}
        />
        {errors.subject && <p className="text-red-600 text-sm mb-2">{errors.subject}</p>}

        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Description"
          rows="4"
          className={`w-full mb-4 px-3 py-2 border rounded focus:outline-none focus:ring-2 transition ${
            errors.description ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
          }`}
        />
        {errors.description && <p className="text-red-600 text-sm mb-2">{errors.description}</p>}

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="px-4 py-2 rounded bg-[#2C4E86] text-white hover:bg-blue-900 transition"
          >
            {isSubmitting ? 'Sending...' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
}
